export function getCoursePackageTypeLabel(pkg) {
  const type = typeof pkg === "string" ? pkg : pkg?.package_type;
  switch (type) {
    case "term1":
      return "ترم أول";
    case "term2":
      return "ترم ثاني";
    case "year":
      return "سنة كاملة";
    case "term":
      return "ترم كامل";
    default:
      return typeof pkg?.type_label === "string" && !pkg.type_label.includes("\u00D8") && !pkg.type_label.includes("\u00C3")
        ? pkg.type_label
        : "ترم كامل";
  }
}